import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppConstants } from '../common/app.constants';


@Injectable({
  providedIn: 'root'
})
export class TokenInterceptorService implements HttpInterceptor {
  

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    const token =sessionStorage.getItem(AppConstants.SESSION_VAR_TOKEN);

    if (!this.isExcludedUrl(request.url)) {
      request = request.clone({
        setHeaders: {
          Authorization: `${token}`
        }
      });
    }

    return next.handle(request);
  }

  private isExcludedUrl(url: string): boolean {
    // Define the URLs that should be excluded from token insertion
    const excludedUrls = ['authenticate'];

    return excludedUrls.some(excludedUrl =>
      url.includes(excludedUrl)
    );
  }
}
